import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

// custom typefaces
import "swiper/css"
import "bootstrap/scss/bootstrap.scss"
import "./src/main.sass"

export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LcMPz4aAAAAAGGAslt9ZIFCO3u2i5hjDRrUswTC"
      scriptProps={{
        defer: true,
      }}
    >
      {element}
    </GoogleReCaptchaProvider>
  )
}

// --- Funktion för att läsa cookie ---
function getCookieValue(name) {
  const cookie = document.cookie
    .split("; ")
    .find(c => c.startsWith(name + "="))
  return cookie ? cookie.split("=")[1] : null
}

// --- Ladda GA dynamiskt ---
function loadGA(GA_ID) {
  if (window.gaLoaded) return
  window.gaLoaded = true

  const script = document.createElement("script")
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  script.async = true
  script.onload = () => {
    const checkGTAG = setInterval(() => {
      if (typeof gtag !== "undefined" && typeof gtag === "function") {
        clearInterval(checkGTAG)
        gtag("config", GA_ID, {
          optimize_id: "OPT_CONTAINER_ID",
          anonymize_ip: true,
          cookie_expires: 0,
        })
      }
    }, 50)

    setTimeout(() => clearInterval(checkGTAG), 5000)
  }

  document.head.appendChild(script)
}

// --- Main entrypoint ---
export const onClientEntry = () => {
  const GA_ID = process.env.ANALYTICS_ID || "G-GT0SV597DC"

  // 1. Kolla om användaren redan har givit analytics consent via cookie
  const cookieValue = getCookieValue("cookieyes-consent")
  if (cookieValue && cookieValue.includes("analytics:yes")) {
    loadGA(GA_ID)
  }

  // 2. Lyssna på event från bannern
  document.addEventListener("cookieyes_consent_update", e => {
    if (e.detail && e.detail.accepted.includes("analytics")) {
      loadGA(GA_ID)
    }
  })
}
